import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';

@Injectable()
export class EncryptionService {
  private _encryptionKeyEndPoint = 'api/DataEncryption';
  constructor(
    private _restApi: RestApi
  ) { }

  public rotateKeys(): Promise<void> {
    return this._restApi.post(`${this._encryptionKeyEndPoint}/RotateMasterEncryptionKey`, null).toPromise();
  }

  public createMasterKey(): Promise<void> {
    return this._restApi.post(`${this._encryptionKeyEndPoint}/CreateMasterEncryptionKey`, null).toPromise();
  }

  public IsMasterKeyCreationEnabled(): Promise<boolean> {
    return this._restApi.get(`${this._encryptionKeyEndPoint}/MasterKey/enable`).toPromise()
      .then((response: any) => response)
      .catch(() => false);
  }

  public SetEntityLogsEnabled(enabled: boolean): Promise<boolean> {
    return this._restApi.post(`${this._encryptionKeyEndPoint}/SetEncryptionForAttribLog/${enabled}`, null).toPromise();
  }

  public IsEntityLogsEnabled(): Promise<boolean> {
    return this._restApi.get(`${this._encryptionKeyEndPoint}/GetEncryptionForAttribLog`).toPromise()
      .then((response: any) => response)
      .catch(() => false);
  }

  public ExistsMasterEncryptionKey(): Promise<boolean> {
    return this._restApi.get(`${this._encryptionKeyEndPoint}/ExistsMasterEncryptionKey`).toPromise()
      .then((response: any) => response)
      .catch(() => false);
  }
}
